module.exports = __webpack_public_path__ + "img/color-icon-label-horizontal.3d251ef.svg";